module.exports = __webpack_public_path__ + "img/Frente-24-00 off.95af8e0f.png";